import { FC, ReactNode } from 'react';
import Text, { TextPresets } from '@stripcash/ui-kit/components/Text';

import s from './styles.module.css';

type LabelNewProps = {
  text: ReactNode;
};

const LabelNew: FC<LabelNewProps> = ({ text }) => (
  <div className={s.labelNew}>
    <Text preset={TextPresets.Caption10}>{text}</Text>
  </div>
);

export default LabelNew;
